
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M2.003 1.526v3.481h3.22"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M9.595 15.414a7 7 0 0 1-2.19 0m6.758-2.8a7 7 0 0 1-1.549 1.55m-8.229-.001a7 7 0 0 1-1.548-1.549M2.66 4.607a7 7 0 0 1 12.736 4.978M10.496 5.87 8.597 9.506 6 9.508"}})])
          )
        }
      }
    